import { ReactComponent as BagNavigation } from "@zarafront/lib-zds/icons/24/bag-navigation.svg";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import { stateConnect } from "src/hooks/state/use-app-state";
import { ProfileShortcut } from "src/pages/Profile/ProfileShortcut/ProfileShortcut";
import { useGridFilterStore } from "src/store/useGridFilters/useGridFilterStore";
import { ROUTE_PATHS } from "src/utils/constants";
import useResponsive from "src/utils/useResponsive";
import "./sidebar-layout.scss";

interface SidebarLayoutProps {
  itemCount: number;
}

const SidebarLayout = ({ itemCount }: SidebarLayoutProps) => {
  const { t } = useTranslation();
  const { WSXS } = useResponsive();
  const history = useHistory();
  const RESET_FILTER = useGridFilterStore(state => state.RESET_SEARCH_FILTER)
  const ariaLabel = itemCount === 0
      ? t("cart-title-empty")
      : t("bag-icon-number", { count: itemCount });

  const handleGoToSearch = () => {
    if (!WSXS) {
      RESET_FILTER();
    }
    history.push(ROUTE_PATHS.SEARCH);
  };

  return (
    <nav className="sidebar" >
      <div className="sidebar__top">
        <button className="sidebar__search-btn zds-label-l" onClick={handleGoToSearch}>
          {t("navigation_search")}
        </button>
      </div>
      <ul className="sidebar__bottom zds-label-l">
        <li className="sidebar__nav-item">
          <span className="visually-hidden" role="status" aria-live="polite">
            {itemCount > 0 && t("bag-icon-number", { count: itemCount })}
          </span>
          <Link to={ROUTE_PATHS.CART} aria-label={ariaLabel} className="sidebar__nav-item__link">
            <span>{t("cart-basket-icon")}</span>
            <div className="sidebar__bag-count">
              <BagNavigation width={20} height={20} className="sidebar__bag-icon" aria-hidden="true" />
              <span className="sidebar__bag-number" aria-hidden="true">
                {Number.isFinite(Number(itemCount)) ? Number(itemCount) : 0}
              </span>
            </div>
          </Link>
        </li>
        <li className="sidebar__nav-item">
          <ProfileShortcut className="sidebar__nav-item__profile" typeIcon="text" />
        </li>
      </ul>
    </nav>
  );
};

export { SidebarLayout };
export default stateConnect(SidebarLayout, (state) => ({
  itemCount: state?.cart?.content?.itemCount ?? 0,
}));
